<template>
    <div class="row" v-if="!loading">
        <div class="col">
            <div class="d-flex justify-content-between grey lighten-3">
                <button type="button" class="ma-2 v-btn v-btn--flat v-btn--icon theme--light v-size--default" @click="prevMonth">
                    <fa-icon :icon="['fas', 'angle-left']"/>
                </button>
                <p class="mb-0 mt-2">{{ current_month ? current_month : $refs.calendar && $refs.calendar.title | capitalize }}</p>
                <button type="button" class="ma-2 v-btn v-btn--flat v-btn--icon theme--light v-size--default" @click="nextMonth">
                    <fa-icon :icon="['fas', 'angle-right']"/>
                </button>
            </div>
            <div class="row">
                <div class="col">
                    <v-calendar
                        ref="calendar"
                        short-months
                        v-model="today"
                        :weekdays="weekday"
                        :type="type"
                        :show-month-on-first="false"
                        :first-day-of-week="1"
                        color="primary"
                        :locale="calendarLocale">
                        <template #day="{ present, past, date }">
                            <div class="row fill-height" style="margin-right: 0;margin-left: 0;">
                                <template v-if="trackedDates[date]">
                                    <v-sheet
                                        v-for="(percent, i) in trackedDates[date]"
                                        :key="i"
                                        :title="category[i]"
                                        :color="colors[i]"
                                        :width="`${percent}%`"
                                        height="12px"
                                        tile/>
                                </template>
                            </div>
                        </template>
                    </v-calendar>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {VCalendar} from 'vuetify/lib/components/VCalendar';
import {VSheet} from 'vuetify/lib/components/VSheet';
import moment from 'moment';
import {mapGetters} from 'vuex';
import Vue from 'vue';
import {eventBus} from '@/main';

export default {
    name: 'AppBookingCalendar',
    props: {
        id: [Number, String],
        dates_chosen: Array,
        booked_dates: [Object, Array],
        unconfirmed_dates: [Object, Array]
    },
    data() {
        return {
            type: 'month',
            weekday: [1, 2, 3, 4, 5, 6, 0],
            current_month: '',
            value: null,
            chosen_dates: this.dates_chosen,
            chosen_times: ['23:59', '23:59'],
            today: moment(new Date()).format('YYYY-MM-DD'),
            loading: false,
            tracked: {},
            colors: ['#fff', '#ee7c00', '#17A2B8', '#1779B8'],
            category: [this.$t('Available'), this.$t('My dates'), this.$t('Unconfirmed'), this.$t('Booked')],
        };
    },
    computed: {
        ...mapGetters(['locale', 'localeDateFormat', 'oneHourPercent', 'localeDatetimeFormat']),
        calendarLocale() {
            if (this.locale === 'et') {
                return 'et-ee';
            } else {
                return 'us-en';
            }
        },
        cal() {
            return this.$refs.calendar;
        },
        trackedDates() {
            return this.tracked;
        }
    },
    methods: {
        setChosenDates() {
            let date = this.chosen_dates[0].split(' ')[0];
            if (this.locale === 'et') {
                let dateArr = date.split('.');
                this.start = moment(new Date(dateArr[2], dateArr[1] - 1, dateArr[0])).format('YYYY-MM-DD');
            } else {
                let dateArr = date.split('/');
                this.start = new Date(dateArr[2], dateArr[0] - 1, dateArr[1]);
            }

            if (this.chosen_dates[0] === null || this.chosen_dates[1] === null) {
                return null;
            }
            let startDate = moment(this.chosen_dates[0].split(' ')[0], this.localeDateFormat);
            let endDate = moment(this.chosen_dates[1].split(' ')[0], this.localeDateFormat);
            let startTime = parseInt(this.chosen_times[0].split(':')[0]);
            let endTime = parseInt(this.chosen_times[1].split(':')[0]);

            let key = 0;
            const period = endDate.diff(startDate, 'days');
            while (startDate <= endDate) {
                if (key === 0) {
                    const start = (24 - startTime) * this.oneHourPercent;
                    Vue.set(this.tracked, moment(startDate).format('YYYY-MM-DD'), [100 - start, start, 0, 0]);
                } else {
                    if (period === key) {
                        const end = (24 - endTime) * this.oneHourPercent;
                        Vue.set(this.tracked, moment(startDate).format('YYYY-MM-DD'), [0, 100 - end, 0, 0]);
                    } else {
                        Vue.set(this.tracked, moment(startDate).format('YYYY-MM-DD'), [0, 100, 0, 0]);
                    }
                }
                startDate = moment(startDate).add(1, 'days');
                ++key;
            }
            this.setBookedDates();
        },
        setBookedDates() {
            this.tracked = Object.assign(this.tracked, this.booked_dates);
            this.setUnconfirmedDates();
        },
        setUnconfirmedDates() {
            this.tracked = Object.assign(this.tracked, this.unconfirmed_dates);
            this.current_month = this.cal.title;
            this.loading = false;
        },
        prevMonth() {
            this.cal.prev();
            this.current_month = null;
        },
        nextMonth() {
            this.cal.next();
            this.current_month = null;
        }
    },
    components: {
        VCalendar,
        VSheet
    },
    mounted() {
        this.loading = true;
        this.setChosenDates();
        eventBus.$on('changeChosenDates', data => {
            let startDate = moment(this.chosen_dates[0].split(' ')[0], this.localeDateFormat);
            let endDate = moment(this.chosen_dates[1].split(' ')[0], this.localeDateFormat);
            while (startDate <= endDate) {
                Vue.delete(this.tracked, moment(startDate).format('YYYY-MM-DD'));
                startDate = moment(startDate).add(1, 'days');
            }
            this.chosen_dates = data.dates;
            this.chosen_times = data.times;
            this.setChosenDates();
        });
    }
};
</script>
<style>
.theme--light.v-btn.v-btn--has-bg {
    background-color: transparent;
}
</style>
